import { resolveJobSponsored } from "../../shared/util/urlUtils";

/**
 * Determines whether engagement-driving UI (benefits, flair) should be
 * removed from an organic job card while the `disco_limited_ui_tst`
 * experiment is active.
 *
 * Applies only to organic jobs in an active bucket of the test (value > 0).
 *
 * @param discoLimitedUiTstValue - the `disco_limited_ui_tst` bucket value
 */
export const shouldRemoveOrganicEngagementUi = (
  discoLimitedUiTstValue: number | undefined,
  sponsored: boolean,
): boolean => !sponsored && (discoLimitedUiTstValue ?? -1) > 0;

/**
 * Applies the limited-UI treatment to a single grouped-relevant-jobs result:
 * returns a copy of the job with organic engagement UI
 * cleared when {@link shouldRemoveOrganicEngagementUi} is true, otherwise the
 * job unchanged.
 */
export function applyLimitedUiToJob<
  T extends {
    tracking?: { jobClick: { url?: string | null; sponsored?: boolean | null } } | null;
    benefits?: unknown;
  },
>(job: T, discoLimitedUiTstValue: number | undefined): T {
  return shouldRemoveOrganicEngagementUi(
    discoLimitedUiTstValue,
    resolveJobSponsored(job.tracking?.jobClick),
  )
    ? { ...job, benefits: [] }
    : job;
}
